module.exports = __webpack_public_path__ + "static/img/yijianjiuyuan.78e7fec.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/aboutus/img/yijianjiuyuan.png
// module id = RJSV
// module chunks = 1